import { render, staticRenderFns } from "./ProfilePassport.vue?vue&type=template&id=12255246&scoped=true&"
import script from "./ProfilePassport.js?vue&type=script&lang=js&"
export * from "./ProfilePassport.js?vue&type=script&lang=js&"
import style0 from "./ProfilePassport.scss?vue&type=style&index=0&id=12255246&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12255246",
  null
  
)

export default component.exports